// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3EL7l","colMaxWidth":"Table_colMaxWidth__3EagT"};